import { client } from "api";

export type DeleteOrderSerialRequest = { productId: string; orderId: string };
export type DeleteOrderSerialResponse = string;

export const deleteOrderSerial = ({ productId, orderId }: DeleteOrderSerialRequest) =>
  client
    .delete<DeleteOrderSerialResponse>(`/order/${orderId}/serials/${productId}`)
    .then((res) => res.data);
